import React from 'react';
import { Avatar, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Tooltip } from '@material-ui/core';
import { AvatarGroup } from '@material-ui/lab';

const useStyles = makeStyles({
  avatarGroup: {
    '& .MuiAvatarGroup-avatar': {
      width: 32,
      height: 32
    }
  }
});

const ViewingUsers = ({ usersArray = [] }) => {
  const { avatarGroup } = useStyles();
  const { users = [] } = useSelector(state => state.bizMeta);

  if (!usersArray.length) return null;

  /**
   *
   * @param {string} username
   */
  function getFullName(username) {
    const user = users.find(u => u.username === username);
    return user ? user.FName + ' ' + user.LName : 'N/A';
  }

  return (
    <AvatarGroup max={5} className={avatarGroup}>
      {usersArray.map(user => {
        const fullName = getFullName(user);

        return (
          <Tooltip key={user} title={fullName} arrow>
            <Avatar
              alt={fullName}
              src={`/api/images/user/${user}/avatar.jpg`}
            />
          </Tooltip>
        );
      })}
    </AvatarGroup>
  );
};

export default ViewingUsers;
